module.exports = __webpack_public_path__ + "img/styria-marketing-services.0809c223.svg";